import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { contentId: String }

  select = async (event) => {
    const presentation = event.target.value
    window.UserPreference?.set('lessons_presentation', presentation)

    const url = new URL(window.location.href)
    url.searchParams.set('presentation', presentation)
    this.request?.abort()
    const request = (this.request = new AbortController())

    try {
      const response = await fetch(url, {
        headers: { Accept: 'text/html' },
        signal: request.signal,
      })
      if (!response.ok) return window.location.assign(url.toString())

      const html = new DOMParser().parseFromString(
        await response.text(),
        'text/html'
      )
      if (request.signal.aborted) return

      const fresh = html.getElementById(this.contentIdValue)
      const current = document.getElementById(this.contentIdValue)
      if (fresh && current) current.replaceWith(fresh)
    } catch {
      if (!request.signal.aborted) window.location.assign(url.toString())
    }
  }
}
